import toast from "react-hot-toast"
import {
  formatDate,
  getToken,
  getUser,
  getUserId,
  toastStyle,
} from "../Utils/Common"
import { getAPICall, postAPICall } from "./axiosMethodCalls"
const user = getUser()
const token = getToken()

//GET
export const getAllItems = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "items/get_all_item",
      {
        requester: user,
        token: token,
        branch_id: id,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getAllItemsByBranch = async (branch_id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "items/get_all_item",
      {
        requester: user,
        token: token,
        branch_id: branch_id,
      }
    )
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const getItem = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "items/get_item",
      {
        requester: user,
        token: token,
        item_id: id,
      }
    )
    return response.data
  } catch (error) {
    return { error: error.response }
  }
}

export const getAllBranchItem = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "items/get_all_item",
      {
        requester: user,
        token: token,
        branch_id: id,
      }
    )
    return response.data
  } catch (error) {
    return { error: error.response }
  }
}

export const createItem = async (itemDetails, itemsUnits) => {
  try {
    var info = {
      requester: user,
      token: token,
      name: itemDetails.size
        ? `${itemDetails.name} ${itemDetails.size}`
        : itemDetails.name, // Concatenate name and size if size exists
      type: itemDetails.type,
      detail: itemDetails.detail,
      is_for_sale: itemDetails.is_for_sale ? "1" : "0",
      is_dsr: itemDetails.is_dsr ? "1" : "0",
      added_by: user,

      barcode: itemDetails.barcode,
      inhouse_barcode: itemDetails.inhouse_barcode,
      tag: itemDetails.tag,
      item_code: itemDetails.item_code,
      serial_number: itemDetails.serial_number,
      // category: itemDetails.category,
      category: itemDetails.category.map((item) => {
        return item.value
      }),
      // subcategory: itemDetails.subcategory,
      brand: itemDetails.brand,
      size: itemDetails.size,
      color: itemDetails.color,
      material: itemDetails.material,
      model: itemDetails.model,
      sales_type: itemDetails.sales_type,
    }
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "items/create",
      info
    )
    //
    //
    return { response: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const editItem = async (itemDetails, itemsUnits) => {
  try {
    var info = {
      requester: user,
      token: token,
      item_id: itemDetails.id,
      name: itemDetails.name,
      type: itemDetails.type,
      detail: itemDetails.detail,
      is_for_sale: itemDetails.is_for_sale ? "1" : "0",
      is_dsr: itemDetails.is_dsr ? "1" : "0",

      barcode: itemDetails.barcode,
      inhouse_barcode: itemDetails.inhouse_barcode,
      tag: itemDetails.tag,
      item_code: itemDetails.item_code,
      serial_number: itemDetails.serial_number,
      // category: itemDetails.category,
      category: itemDetails.category.map((item) => {
        return item.value
      }),
      // subcategory: itemDetails.subcategory,
      brand: itemDetails.brand,
      size: itemDetails.size,
      color: itemDetails.color,
      material: itemDetails.material,
      model: itemDetails.model,
      sales_type: itemDetails.sales_type,

      //item_units
      item_unit_id: itemsUnits.map((item) => {
        return item.id
      }),

      unit_from: itemsUnits.map((item) => {
        return item.unit_from
      }),

      value_from: itemsUnits.map((item) => {
        return item.value_from
      }),

      unit_to: itemsUnits.map((item) => {
        return item.unit_to
      }),

      value_to: itemsUnits.map((item) => {
        return item.value_to
      }),

      min: itemsUnits.map((item) => {
        return item.min
      }),

      max: itemsUnits.map((item) => {
        return item.max
      }),

      acceptable_variance: itemsUnits.map((item) => {
        return item.acceptable_variance
      }),

      price: itemsUnits.map((item) => {
        return item.price ? item.price : ""
      }),
    }
    //

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "items/update",
      { ...info }
    )
    //
    return { response: response.data }
  } catch (error) {
    return { error: error }
  }
}

//GET
export const searchItem = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "items/search",
      {
        requester: user,
        token: token,
        item_id: data.item_id,
        branch_id: data.branch_id,
        name: data.name,
        anything: data.anything,
        has_barcode: data.has_barcode,
        sales_type: data.sales_type,
        category_name: data.category,
        subcategory_name: data.subcategory,
        brand_name: data.brand,
        barcode: data.barcode,
        page: data.page,
      }
    )
    //
    return { response: response.data }
  } catch (error) {
    return { error: error.response }
  }
}

export const deleteItem = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "items/delete",
      {
        requester: user,
        token: token,
        item_id: id,
      }
    )
    return { data: response }
  } catch (error) {
    if (error.response.status === 401) {
      toast.error("Unauthorized access: another device is using this account", {
        style: toastStyle(),
      })
      //   removeSession();
    }
    return { error: error.response }
  }
}
